(function () {
  'use strict';

  angular
      .module('tfc.Terms')
      .factory('Terms', Terms);

  // @ngInject
  function Terms(Api, Auth, CookieJar, $q) {

    return {
      getTermsOfUse: getTermsOfUse,
      acceptTermsOfUse: acceptTermsOfUse,
      cookieExistsAndAccepted: cookieExistsAndAccepted,
      getCookie: getCookie,
      isAccepted: isAccepted
    };

    function getTermsOfUse(uuid) {
      return Api.get('/users/' + uuid + '/terms-of-use');
    }

    function acceptTermsOfUse(uuid) {
      return Api.post('/users/'+uuid+'/terms-of-use/accept');
    }

    function setTermsCookie() {
      var user = Auth.getUser();
      if(user){
        return getTermsOfUse(user.uuid).then(
            function (responseSuccess) {
              if(responseSuccess.status === 200) {
                CookieJar.set({name: 'tfc-retailer-terms', value: _.toString('accepted')});
              }else if(responseSuccess.status === 204){
                CookieJar.set({name: 'tfc-retailer-terms', value: _.toString('notRequired')});
              }
            },
            function (responseFailure) {
              if (responseFailure.status === 404) {
                CookieJar.set({name: 'tfc-retailer-terms', value: _.toString('notAccepted')});
              }
            });
      }else {
        return $q.reject();
      }
    }

    function getCookie() {
      return CookieJar.get('tfc-retailer-terms');
    }

    function cookieExistsAndAccepted() {
      var termsCookieValue = getCookie();
      return termsCookieValue === 'accepted' || termsCookieValue === 'notRequired';
    }

    function isAccepted() {
      return $q(function(resolve,reject){
        if(getCookie()){
          resolve(cookieExistsAndAccepted());
        }else{
          setTermsCookie()
              .then(function () {
                resolve(cookieExistsAndAccepted());
              },reject);
        }
      });
    }

  }

})();